/**
 * Asynchronously loads the Data Catalog container.
 */
import { lazy } from 'react';

export const DataCatalog = lazy(() =>
  import('./index').then(module => ({ default: module.DataCatalog })),
);
